import type { IndexOfExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const arrayIndexResolver =
  createSimpleNamedExpressionResolver<IndexOfExpression>(
    'arrayIndex',
    (array, key, searchValue) =>
      array.findIndex(object => object[key] === searchValue)
  );
